// src/utils/csvUtils.js

export function jsonToCSV(items) {
  if (!items || !items.length) return "";

  const header = Object.keys(items[0]);
  const csvRows = [];

  // Header row
  csvRows.push(header.join(","));

  // Data rows
  for (const row of items) {
    const values = header.map((fieldName) => {
      let val = row[fieldName] ?? "";
      if (typeof val === "string") {
        val = val.replace(/"/g, '""'); // Escape quotes
        return `"${val}"`;
      }
      return val;
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
}

export function downloadCSV(data, filename = "logs.csv") {
  const csv = jsonToCSV(data);
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
